export default "__VITE_ASSET__C9AL7IJI__"